/* !
 * recipes.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	// 右フロートメニュー お気に入り件数取得
	FUNCTIONS.setFavoriteCount = () => {
		let favoStorage = [];
		for (let i in localStorage) {
			if (i.indexOf('pokkasapporoFavoriteRecipeList-') !== -1) { favoStorage.push(i); }
		}
		if (favoStorage.length) {
			let recipeParams = '';
			favoStorage.forEach(ele => {
				recipeParams += `&p_recipe_id=${ele.replace(/pokkasapporoFavoriteRecipeList-/, '')}`;
			});
			recipeParams = recipeParams.slice(1);

			fetch(`/ajax/recipes/detail/data.json?${recipeParams}`).then(response => response.json()).then(data => {
				if (data.rt_bn_recipe_detail.length) {
					let recipeData = data.rt_bn_recipe_detail;
					let publishedRecipeList = [];
					recipeData.forEach(ele => {
						if (ele.cf_r_status) {
							publishedRecipeList.push(ele);
						} else {
							localStorage.removeItem(`pokkasapporoFavoriteRecipeList-${ele._key}`);
						}
					});
					document.querySelector('.recipe-floatMenu .__count').textContent = publishedRecipeList.length;
				}
			});
		} else {
			document.querySelector('.recipe-floatMenu .__count').textContent = '0';
		}
	};

	if (document.getElementsByClassName('recipe-floatMenu').length) {
		FUNCTIONS.setFavoriteCount();
	}

})(window.FUNCTIONS);